import { Product } from "@/types";

export const toLiked = (product: Product, liked: Product[], setLiked: React.Dispatch<React.SetStateAction<Product[]>>) => {
    if (liked.find((item) => item.id === product.id)) {
        const newLiked = liked.filter((item) => item.id !== product.id);
        setLiked(newLiked);
        localStorage.setItem("liked", JSON.stringify(newLiked));
        return;
    }
    const newLiked = [...liked, product];
    setLiked(newLiked);
    localStorage.setItem("liked", JSON.stringify(newLiked));
};

export const getLiked = (setLiked: React.Dispatch<React.SetStateAction<Product[]>>) => {
    const liked = localStorage.getItem("liked");
    if (liked && liked.length > 0) {
        setLiked(JSON.parse(liked));
    }
}